import { getStores, hasSDK } from '@littlebird/sdk';
import { useEffect } from 'react';

import { logError } from '@/lib/errorLogging';

import type { EntityReference } from '@littlebird/markdown-utils';

export const useEnsureEntityReferenceLoaded = ({
  entity,
  attributes: { id },
}: EntityReference) => {
  const stores = hasSDK() ? getStores() : undefined;
  const store =
    entity === 'chat'
      ? stores?.threads
      : entity === 'meeting'
        ? stores?.meetings
        : undefined;

  useEffect(() => {
    if (!store) return;

    void store.ensureLoaded(id).catch((error) => {
      logError(error, 'Failed to load entity reference', {
        context: 'EntityReferenceChip',
        metadata: { entity, id },
      });
    });
  }, [entity, id, store]);
};
